import { InboxLayout } from '@/features/inbox';

export function InboxPage() {
  return <InboxLayout />;
}
